import { Advice } from '../translations-types';

const translations: Advice = {
  addAdvice: 'Add Advice module',
  addAdviceCondition: 'Add Advice module condition',
  addAdviceGroup: 'Add Advice module group',
  adviceName: 'Advice module name',
  successfullyUpdated: 'Successfully updated advice',
  successfullyCreated: 'Successfully created advice',
  createAdvice: 'Create Advice module',
  viewAdvice: 'View Advice module',
  editAdvice: 'Edit Advice module',
  enterNewGroupName: 'Enter new group name',
  group: 'Group',
  adviceConditionName: 'Advice module condition name',
  adviceGroupName: 'Advice module group name',
  questions: 'Questions',
  areYouSureYouWantToDeleteAdviceGroup: 'Are you sure you want to delete this Advice module group?',
  areYouSureYouWantToDeleteAdviceCondition: 'Are you sure you want to delete this Advice module condition?',
  conditions: 'Conditions',
  advice: 'Advice module',
  addOption: 'Add option',
  podcastUrl: 'Podcast URL',
  videoUrl: 'Video URL',
  adviceOrUrl: 'Advice module content can be provided as text or as a URL.',
  watchOnVimeo: 'Watch on Vimeo',
  listedOnSpotify: 'Listen on Spotify',
  conditionsOrLogic: 'Advice module will be displayed if any of these conditions is met.',
  groupIsUsedTimes: 'This group is used {{count}} times.',
  conditionIsUsedTimes: 'This condition is used {{count}} times.',
  noAdvice: 'No Advice module to display.',
  conditionModalInfoText: 'Condition will be matched if all subconditions are met.',
  adviceX: 'Advice module {{number}}',
  audio: 'Audio',
  changeAudio: 'Change audio',
  removeAudio: 'Remove audio',
  chooseAudio: 'Choose audio',
  generateAdvice: 'Generate Advice',
  generating: 'Generating...',
  regenerate: 'Regenerate',
  generated: 'Generated',
  resenceAdvice: 'Re-sence Advice',
  assistantsAdvice: 'Assistants Advice',
};

export default translations;
